import { Deserializable } from '../interfaces';

export class AboutMe implements Deserializable {
  idTarjeta: string;
  titulo: string;
  descripcion: string;
  correo: string;
  claveTelefono: string;
  telefono: string;
  CP: string;
  idPais: string;
  idEntidad: string;
  idMunicipio: string;
  domicilio: string;
  urlLogo: File | string;
  urlLogoTemp: string;
  idUsuario: string;
  idioma: string;

  constructor() {
    this.idTarjeta = '';
    this.titulo = '';
    this.descripcion = '';
    this.correo = '';
    this.claveTelefono = '';
    this.telefono = '';
    this.CP = '';
    this.idPais = '0';
    this.idEntidad = '0';
    this.idMunicipio = '0';
    this.domicilio = '';
    this.urlLogo = '';
    this.urlLogoTemp = '';
    this.idUsuario = '';
    this.idioma = '';
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
